import { useCallback, useEffect, useState } from 'react';
import { getSubscription, type SubscriptionState } from '../../../utils/subscriptionApi';

interface UseSubscriptionResult {
  state: SubscriptionState | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
  setState: (next: SubscriptionState) => void;
}

export function useSubscription(): UseSubscriptionResult {
  const [state, setState] = useState<SubscriptionState | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const fresh = await getSubscription();
      setState(fresh);
    } catch (err) {
      setError((err as Error).message || 'Failed to load subscription.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { state, loading, error, refetch, setState };
}
